import { getWorkerTemplateConfigForCountry } from "@/config/workerCountryTemplateMap";

export function expectedTemplateForCountry(country: string): {
  template: string;
  language: string;
  templateName: string;
} {
  const cfg = getWorkerTemplateConfigForCountry(country);
  return {
    template: cfg.templateName || "BaseTemplate",
    templateName: cfg.templateName || "BaseTemplate",
    language: cfg.language || "en-US",
  };
}
